import { Container } from '#app/components/ui'
import backgroundImage from '#app/images/background-faqs.jpg'

const faqs = [
	[
		{
			question:
				'How does the Event Timelines app help manage complex event schedules?',
			answer:
				'The Event Timelines app is designed to simplify your event planning process. It allows you to create, customize, and visualize detailed event timelines, helping you track tasks, milestones, and dependencies in one place.',
		},
		{
			question: 'Can I collaborate with my team members on event timelines?',
			answer:
				'Absolutely! The app offers robust collaboration tools, enabling seamless teamwork. You can assign tasks, set deadlines, and receive real-time updates to ensure everyone stays on track.',
		},
		{
			question: `What happens if my event details change after I've created a timeline?`,
			answer:
				'No worries! Our app supports real-time updates. Simply make adjustments to your event timeline, and the changes will be reflected instantly for your team and stakeholders.',
		},
	],
	[
		{
			question:
				'Is my event data safe and secure with the Event Timelines app?',
			answer:
				'Absolutely. We prioritize the security of your data. Our app employs the latest encryption and security measures to ensure your event information is protected at all times.',
		},
		{
			question: 'Can I export event timelines for presentations or sharing?',
			answer:
				'Certainly! The app allows you to export your event timelines in various formats, making it easy to share with clients, vendors, or team members for presentations or collaborative purposes.',
		},
		{
			question: 'Does the app provide analytics to optimize event planning?',
			answer:
				'Yes! Our app includes AI-driven predictive analytics that help you identify potential bottlenecks and make informed decisions to ensure smooth event execution.',
		},
	],
	[
		{
			question:
				'How does the vendor management feature work in the Event Timelines app?',
			answer:
				'The app offers a dedicated vendor management feature that enables you to streamline communication and collaboration with vendors. You can assign tasks, track progress, and ensure a seamless vendor coordination process.',
		},
		{
			question: 'Can I customize the appearance of my event timelines?',
			answer:
				'Absolutely! The app allows you to customize the appearance of your event timelines, ensuring they align with your branding and event theme.',
		},
		{
			question:
				'Is customer support available for users of the Event Timelines app?',
			answer:
				'Yes, we provide comprehensive customer support to assist you with any questions or issues you might encounter while using the app. Feel free to reach out to our support team for assistance.',
		},
	],
]

export default function Faqs() {
	return (
		<section
			id="faq"
			aria-labelledby="faq-title"
			className="relative overflow-hidden bg-slate-50 py-20 sm:py-32"
		>
			<img
				className="absolute left-1/2 top-0 max-w-none -translate-y-1/4 translate-x-[-30%]"
				src={backgroundImage}
				alt=""
				width={1558}
				height={946}
			/>
			<Container className="relative">
				<div className="mx-auto max-w-2xl lg:mx-0">
					<h2
						id="faq-title"
						className="font-display text-3xl tracking-tight text-slate-900 sm:text-4xl"
					>
						Frequently asked questions
					</h2>
					<p className="mt-4 text-lg tracking-tight text-slate-700">
						If you can’t find what you’re looking for, email our support team
						and if you’re lucky someone will get back to you.
					</p>
				</div>
				<ul className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-8 lg:max-w-none lg:grid-cols-3">
					{faqs.map((column, columnIndex) => (
						<li key={columnIndex}>
							<ul className="flex flex-col gap-y-8">
								{column.map((faq, faqIndex) => (
									<li key={faqIndex}>
										<h3 className="font-display text-lg leading-7 text-slate-900">
											{faq.question}
										</h3>
										<p className="mt-4 text-sm text-slate-700">{faq.answer}</p>
									</li>
								))}
							</ul>
						</li>
					))}
				</ul>
			</Container>
		</section>
	)
}
